import React from 'react';

export const blockMouseEvent = <T>(event: React.MouseEvent<T>) => {
  event.preventDefault();
};
